/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/toolRecommendations/components/LearnByDoing/LearnByDoingCTAScreen.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { useState } from 'react';
import { chirpEnumToString } from 'academy-common-lib/utils/chirp';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Image } from 'foundations-components/transitional/components/Image';
import { Flex } from 'foundations-components/components/Flex';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { View } from 'foundations-components/components/View';
import UsageTracker from '../../../../utils/UsageTracker';
import LearnWhileDoingButton from '../LearnByDoing/LearnByDoingButton.migrated';
import { useRequestLearnWhileDoing } from '../../hooks.migrated';
import { useFullShort } from '../../../shortContent/shortContentQueries.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// Full-screen CTA with background image and two action buttons
const LearnByDoingCtaScreen = ({
  backgroundImage,
  otgId
}) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  const {
    short
  } = useFullShort(Number(otgId), !otgId);
  const videoType = chirpEnumToString(short === null || short === void 0 ? void 0 : short.shortFormContentType);
  const visibility = chirpEnumToString(short === null || short === void 0 ? void 0 : short.visibility);
  const {
    handlePlayHsVideo,
    handleDisableLearnWhileDoingScreen,
    isVideoPlayed,
    isVideoFinished
  } = useRequestLearnWhileDoing();

  // Handles click on "Watch here instead" button
  const handlePlayInAcademy = () => {
    handlePlayHsVideo();
    handleDisableLearnWhileDoingScreen();
    UsageTracker.trackStandalone('Content Interaction', {
      action: 'learn-by-doing-cta-play-in-academy-clicked',
      shortId: String(otgId),
      contentId: String(otgId),
      videoType,
      visibility
    });
  };
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "learn-by-doing-cta-screen",
    position: "relative",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      position: "relative",
      children: [/*#__PURE__*/_jsx(Image, {
        alt: "learn-by-doing-cta-screen",
        onLoad: () => setImgLoaded(true),
        src: backgroundImage
      }), imgLoaded ? /*#__PURE__*/_jsx(View, {
        backgroundColor: "specialty-scrim",
        blockSize: "100%",
        inlineSize: "100%",
        insetBlockEnd: "0",
        insetInlineStart: "0",
        position: "absolute",
        children: /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          blockSize: "100%",
          flexDirection: "column",
          justifyContent: "center",
          children: /*#__PURE__*/_jsx(Flex, {
            inlineSize: "50%",
            justifyContent: "center",
            paddingInline: "500",
            children: /*#__PURE__*/_jsxs(Flex, {
              flexDirection: "column",
              gap: "400",
              inlineSize: "100%",
              children: [/*#__PURE__*/_jsx(LearnWhileDoingButton, {
                otgId: otgId
              }), /*#__PURE__*/_jsx(Button, {
                block: true,
                borderColor: "border-brand-default",
                borderRadius: "full",
                borderWidth: "100",
                "data-test-id": "play-in-academy-button",
                margin: "0",
                onClick: handlePlayInAcademy,
                paddingBlock: "400",
                size: "medium",
                use: "secondary",
                children: /*#__PURE__*/_jsx(Flex, {
                  alignItems: "center",
                  children: !isVideoFinished && isVideoPlayed ? /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "learningCenter.learnByDoing.continueHere"
                  }) : /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "learningCenter.learnByDoing.watchInAcademy"
                  })
                })
              })]
            })
          })
        })
      }) : /*#__PURE__*/_jsx(View, {
        blockSize: "600px",
        children: /*#__PURE__*/_jsx(LoadingOverlay, {
          contextual: true,
          layout: "centered",
          padding: "1700",
          use: "spinner"
        })
      })]
    })
  });
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/toolRecommendations/components/LearnByDoing/LearnByDoingCTAScreen.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export default LearnByDoingCtaScreen;